import axios from "axios";
import store from "./store";
import router from "./router";

const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API,
    headers: {
        "Content-Type": "application/json",
    },
    timeout: 60000
});

apiClient.interceptors.request.use(
    (config) => {
        const token = store.getters.getAccessToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                await store.dispatch("refreshToken");
                const token = store.getters.getAccessToken;
                apiClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
                originalRequest.headers["Authorization"] = `Bearer ${token}`;
                return apiClient(originalRequest);
            } catch (e) {
                // The refresh token is gone or rejected -- the session really is over.
                // "/login" is not a route; the sign-in page is "/signin", so the old
                // redirect landed the user on the 404 catch-all.
                store.dispatch("logout");
                router.push("/signin");
            }
        }
        return Promise.reject(error);
    }
);

export default apiClient;
